import React from "react";
import { Grid2 } from "@mui/material";
// styles
import styles from "./Manage.module.scss";

export default function Manage({ header, title, button, icon: Icon, onClick }) {
  return (
    <>
      <Grid2 className={styles.ManageContainer}>
        <Grid2 className={styles.IconFlexBox}>
          <Icon className={styles.icon} />
        </Grid2>
        <Grid2 className={styles.Flexbox}>
          <Grid2 className={styles.header}>{header}</Grid2>
          <Grid2 className={styles.title}>{title}</Grid2>
          <Grid2 className={styles.button} onClick={onClick}>
            {button}
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}
